var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analyses__list"},_vm._l((_vm.sortedAnalysesList),function(analysis){return _c('analysis-item',{key:analysis.uuid,attrs:{"analysis":analysis},on:{"analysis:delete":_vm.sendAnalysisToDelete}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }